<template>
  <div class="modal-header-container"><FAIcon v-if="icon" :icon="icon" /> {{ title }}</div>
</template>

<script>
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "ModalHeader",
  components: { FAIcon },
  props: {
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
  .modal-header-container{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
  }
</style>
